import { graphql } from '@/gql';
import type { SearchGroceryAvailableStoresQuery, SearchGroceryAvailableStoresQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type GroceryAvailableStore = SearchGroceryAvailableStoresQuery['searchGroceryAvailableStores'][number];

export const searchGroceryAvailableStores = async ({
  streetAddress,
  city,
  state,
  zip,
  latitude,
  longitude,
  country,
}: SearchGroceryAvailableStoresQueryVariables): Promise<GroceryAvailableStore[]> => {
  const response = await queryExecute({
    query: graphql(`
      query SearchGroceryAvailableStores(
        $streetAddress: String!
        $city: String!
        $state: String!
        $zip: String!
        $latitude: Float
        $longitude: Float
        $country: String!
      ) {
        searchGroceryAvailableStores(
          streetAddress: $streetAddress
          city: $city
          state: $state
          zip: $zip
          latitude: $latitude
          longitude: $longitude
          country: $country
        ) {
          id
          name
          slug
          description
          logo
        }
      }
    `),
    variables: {
      streetAddress,
      city,
      state,
      zip,
      latitude,
      longitude,
      country,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.searchGroceryAvailableStores;
};
